import { PersistConfig, StorageAdapter } from '@lumora/common';
import { AnyAction, Reducer } from '@reduxjs/toolkit';

/**
 * Web storage adapter - no persistence, uses in-memory state only
 * Web apps typically rely on session cookies and don't persist Redux state
 */
export const webStorageAdapter: StorageAdapter = {
  wrapReducer<S = unknown, A extends AnyAction = AnyAction>(
    reducer: Reducer<S, A>,
    _config: PersistConfig
  ): Reducer<S, A> {
    // On web, we don't persist state - just return the original reducer
    return reducer;
  },

  getMiddlewareConfig: () => ({
    serializableCheck: {
      // Still ignore persist actions in case they come from somewhere
      ignoredActions: [
        'persist/PERSIST',
        'persist/REHYDRATE',
        'persist/REGISTER',
      ],
    },
  }),

  // Web doesn't need a persistor
  createPersistor: undefined,
};
